import { render, staticRenderFns } from "./BasicInfo.vue?vue&type=template&id=af6f8782&scoped=true&"
import script from "./BasicInfo.vue?vue&type=script&lang=js&"
export * from "./BasicInfo.vue?vue&type=script&lang=js&"
import style0 from "./BasicInfo.vue?vue&type=style&index=0&id=af6f8782&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af6f8782",
  null
  
)

component.options.__file = "BasicInfo.vue"
export default component.exports